import React, {forwardRef} from 'react';
import './ModalDialogFooter.scss';

interface ModalDialogFooterProps {
  buttonsRight?: React.ReactNode;
  buttonsLeft?: React.ReactNode;
}

export const ModalDialogFooter = forwardRef(
  ({ buttonsRight, buttonsLeft }: ModalDialogFooterProps, ref: React.Ref<HTMLDivElement>) => (
    <div ref={ref} className="modal-dialog-footer">
      <div className="modal-dialog-footer__buttons-container">{buttonsLeft}</div>
      <div className="modal-dialog-footer__buttons-container">{buttonsRight}</div>
    </div>
  )
);
